var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.dataLoading),expression:"dataLoading"}],staticClass:"swiper-container",attrs:{"id":"microPageMulti"}},[_c('div',{class:{
      background_music_icon:
        _vm.microPageData && _vm.microPageData.background_music && !_vm.audioPlaying,
      background_music_icon_play:
        _vm.microPageData && _vm.microPageData.background_music && _vm.audioPlaying,
    },on:{"click":_vm.playOrPauseMusic}},[_c('i')]),_c('div',{staticClass:"swiper-wrapper"},[(_vm.microPageData !== null)?[_vm._l((_vm.microPageData.pages),function(item,index){return [_c('div',{key:index,staticClass:"swiper-slide",style:({
            position: 'relative',
            backgroundImage:
              'url(' +
              _vm.baseURL +
              (item.background_img || _vm.microPageData.background_img) +
              ')',
          })},[_vm._l((item.items),function(module,indexs){return [(module.type === 1)?[_c('img',{key:index + '_' + indexs,class:['module-images', 'animated', module.dynamicEffect],style:({
                  position: 'absolute',
                  top: module.top + 'px',
                  left: module.left + 'px',
                  width: module.width - 10 + 'px',
                  height: module.height - 10 + 'px',
                  backgroundImage: 'url(' + (_vm.baseURL + module.theme) + ')',
                  padding: '5px',
                  animationDuration: module.dynamicDuration + 's',
                  animationDelay: module.dynamicDelay + 's',
                }),attrs:{"src":module.src === ''
                    ? _vm.baseURL + 'logo/logo3.png'
                    : _vm.baseURL + module.src}})]:_vm._e(),(module.type === 2)?[_c('span',{key:index + '_' + indexs,class:['module-text', 'animated', module.dynamicEffect],style:({
                  position: 'absolute',
                  top: module.top + 'px',
                  left: module.left + 'px',
                  width: module.width + 'px',
                  height: module.height + 'px',
                  color: module.text_color,
                  fontSize: module.text_size + 'px',
                  backgroundImage: 'url(' + (_vm.baseURL + module.theme) + ')',
                  animationDuration: module.dynamicDuration + 's',
                  animationDelay: module.dynamicDelay + 's',
                })},[_vm._v(" "+_vm._s(module.text)+" ")])]:_vm._e(),(module.type === 3)?[_c('video',{key:index + '_' + indexs,ref:'video_' + index + '_' + indexs,refInFor:true,class:['module-text', 'animated', module.dynamicEffect],style:({
                  position: 'absolute',
                  top: module.top + 'px',
                  left: module.left + 'px',
                  width: module.width + 'px',
                  height: module.height + 'px',
                  animationDuration: module.dynamicDuration + 's',
                  animationDelay: module.dynamicDelay + 's',
                }),attrs:{"controls":"controls","src":module.src === ''
                    ? _vm.baseURL + 'logo/logo3.png'
                    : _vm.baseURL + module.src}},[_vm._v(" 您的浏览器不支持 video 标签。 ")])]:_vm._e(),(module.type === 4)?[_c('a',{key:index + '_' + indexs,class:[
                  'module-text',
                  'animated',
                  module.dynamicEffect,
                  'phone-theme ' + module.theme ],style:({
                  padding: '0px',
                  position: 'absolute',
                  top: module.top + 'px',
                  left: module.left + 'px',
                  width: module.width + 'px',
                  height: module.height + 'px',
                  animationDuration: module.dynamicDuration + 's',
                  animationDelay: module.dynamicDelay + 's',
                }),attrs:{"href":'tel:' + module.text}},[_c('div',{staticClass:"left-side",style:({
                    background:
                      '#52cadb url(' +
                      _vm.baseURL +
                      'microPageModulesResources/images/multiPage/phone/' +
                      module.theme +
                      '-l.png' +
                      ') no-repeat',
                  })},[_c('i',{staticClass:"el-icon-phone"})]),_c('div',{staticClass:"right-side",style:({
                    background:
                      '#52cadb url(' +
                      _vm.baseURL +
                      'microPageModulesResources/images/multiPage/phone/' +
                      module.theme +
                      '-r.png' +
                      ') no-repeat',
                    'margin-left': '-1px',
                  })},[_c('div',[_vm._v(_vm._s(module.name))]),_c('div',[_vm._v(_vm._s(module.text))])])])]:_vm._e(),(module.type === 5)?[_c('a',{key:index + '_' + indexs,class:[
                  'module-text',
                  'animated',
                  module.dynamicEffect,
                  'link-theme ' + module.theme ],style:({
                  padding: '0px',
                  position: 'absolute',
                  top: module.top + 'px',
                  left: module.left + 'px',
                  width: module.width + 'px',
                  height: module.height + 'px',
                  animationDuration: module.dynamicDuration + 's',
                  animationDelay: module.dynamicDelay + 's',
                }),attrs:{"href":module.text,"target":"_blank"}},[_c('div',{staticClass:"left-side",style:({
                    background:
                      '#52cadb url(' +
                      _vm.baseURL +
                      'microPageModulesResources/images/multiPage/link/' +
                      module.theme +
                      '-l.png' +
                      ') no-repeat',
                  })},[_c('i',{staticClass:"el-icon-link"})]),_c('div',{staticClass:"right-side",style:({
                    background:
                      '#52cadb url(' +
                      _vm.baseURL +
                      'microPageModulesResources/images/multiPage/link/' +
                      module.theme +
                      '-r.png' +
                      ') no-repeat',
                    'margin-left': '-1px',
                  })},[_c('div',[_vm._v(_vm._s(module.name))])])])]:_vm._e(),(module.type === 6)?[_c('a',{key:index + '_' + indexs,class:[
                  'module-text',
                  'animated',
                  module.dynamicEffect,
                  'link-theme ' + module.theme ],style:({
                  padding: '0px',
                  position: 'absolute',
                  top: module.top + 'px',
                  left: module.left + 'px',
                  width: module.width + 'px',
                  height: module.height + 'px',
                  animationDuration: module.dynamicDuration + 's',
                  animationDelay: module.dynamicDelay + 's',
                }),attrs:{"href":module.text,"target":"_blank"}},[_c('baidu-map',{class:'map-theme ' + module.theme,style:({
                    width: module.width + 'px',
                    height: module.height + 'px',
                  }),attrs:{"point":[module.lng, module.lat]}})],1)]:_vm._e()]})],2)]})]:_vm._e()],2),_c('div',{staticClass:"swiper-pagination"}),_c('img',{staticClass:"mircropage-arrow",attrs:{"src":require("@/assets/images/mircropage_arrow.png")}}),(_vm.microPageData && _vm.microPageData.background_music)?_c('audio',{ref:"audio",attrs:{"loop":_vm.microPageData.loop,"autoplay":_vm.microPageData.autoPlay,"src":_vm.baseURL + _vm.microPageData.background_music}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }